import React from "react";
import { useNavigate } from "react-router-dom";
import {
  useFollowUserMutation,
  useUnfollowUserMutation,
} from "../../src/store/api/followApi";
import { useGetPostLikesQuery } from "../../src/store/api/postApi";
import styles from "./PostLikesModal.module.css";

const PostLikesModal = ({ postId, postType, open, onClose }) => {
  const navigate = useNavigate();
  const currentUserId = localStorage.getItem("userId");
  const { data: users = [], refetch } = useGetPostLikesQuery(
    { postId, type: postType, page: 1, pageSize: 20 },
    { skip: !open, refetchOnMountOrArgChange: true }
  );

  const [followUser] = useFollowUserMutation();
  const [unfollowUser] = useUnfollowUserMutation();

  const handleFollowToggle = async (user, e) => {
    e.stopPropagation();

    try {
      if (user.isFollowing) {
        await unfollowUser(user.id).unwrap();
      } else {
        await followUser(user.id).unwrap();
      }

      // refresh likes list
      refetch();
    } catch (err) {
      console.error("Follow toggle failed", err);
    }
  };

  if (!open) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <h3>Likes</h3>
          <button onClick={onClose}>✕</button>
        </div>

        <div className={styles.list}>
          {users.map((user) => (
            <div key={user.id} className={styles.userRow}>
              
              <div
                className={styles.userInfo}
                onClick={() => {
                  onClose(); // close modal before navigating
                  navigate(`/profile/${user.id}`);
                }}
              >
                 {user.profilePhotoUrl ? (
                <img
                  src={user.profilePhotoUrl}
                  alt={user.name}
                  className={styles.avatar}
                />
              ) : (
                <div className={styles.noPhoto}>
                  {user.name
                    ?.split(' ')
                    .map((w) => w[0])
                    .slice(0, 2)
                    .join('')
                    .toUpperCase() || '?'}
                </div>
              )}
                <span className={styles.name}>{user.name}</span>
              </div>

              {user.id !== currentUserId && (
  <button
    className={
      user.isFollowing ? styles.unfollowBtn : styles.followBtn
    }
    onClick={(e) => handleFollowToggle(user, e)}
  >
    {user.isFollowing ? "Unfollow" : "Follow"}
  </button>
)}

            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PostLikesModal;